import { Suspense } from 'react';
import ReactDOM from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import { HelmetProvider } from 'react-helmet-async';
//
import TimeAgo from 'javascript-time-ago';
import en from 'javascript-time-ago/locale/en.json';
//
import App from './App';
//
import * as serviceWorkerRegistration from './serviceWorkerRegistration';
//
import { store } from './store/store'
import { Provider } from 'react-redux'

TimeAgo.addDefaultLocale(en);

// ----------------------------------------------------------------------

const root = ReactDOM.createRoot(document.getElementById('root'));

root.render(
  <HelmetProvider>
    <BrowserRouter>
      <Suspense>
        <Provider store={store}>
          <App />
        </Provider>
      </Suspense>
    </BrowserRouter>
  </HelmetProvider>
);

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://cra.link/PWA
serviceWorkerRegistration.register();

if (process.env.REACT_APP_ENV === "Live") console.log = () => {};